import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClientService:HttpClientService) { }

  public getSalesAmountPerMonth(filter: string = '12m') {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_SALESAMOUNTPERMONTH}?filter=${filter}`);
  }

  public getSalesDashboardData(filter: string = '6M', warehouseId?: number) {
    return this.httpClientService.get(
      `${CONFIG.DASHBOARD.GET_SALES_DASHBOARD_DATA}?filter=${filter}&warehouseId=${warehouseId}`
    );
  }

  public getHomeDashboardData() {
    return this.httpClientService.get(CONFIG.DASHBOARD.GET_HOMEDASHBOARDDATA);
  }

  public getTopSellingProducts(filter: string = '12m') {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_TOPSELLINGPRODUCTS}?filter=${filter}`);
  }

  public getRecentSales(user:string, filter: string = '12m') {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_RECENTSALES}?createdBy=${user}&filter=${filter}`);
  }

  public getInventoryStockDistribution(warehouseId?: number) {
    return this.httpClientService.get(
      `${CONFIG.DASHBOARD.INVENTORY_STOCK_DISTRIBUTION}?warehouseId=${warehouseId}`
    );
  }

  public getRecentPO() {
    return this.httpClientService.get(CONFIG.DASHBOARD.GET_RECENTPO);  
  }

  public getOrderStatistics(warehouseId: number) {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_ORDERSTATISTICS}?warehouseId=${warehouseId}`);
  }
  
  public getPOStatistics(warehouseId: number) {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_POSTATISTICS}?warehouseId=${warehouseId}`);
  }
 
  public getOpenPOTransaction(warehouseId: number) {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_OPENPO_TRANSACTION}?warehouseId=${warehouseId}`);
  }
  
  public getPendingShipmentTransaction(warehouseId: number) {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_PENDING_SHIPMENT_TRANSACTION}?warehouseId=${warehouseId}`);
  }
  
  public getTopPOReceiptTransactions() {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_TOP_PORECEIPT_TRANSACTION}`);
  }
  
  public getTopSalesTransactions() {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_TOP_SALES_TRANSACTION}`);
  }
  
  public getInventoryValueByWarehouse() {
    return this.httpClientService.get(`${CONFIG.DASHBOARD.GET_INVENTORY_VALUE_BY_WAREHOUSE}`);
  }

  public getProjectDashboardData() {
    return this.httpClientService.get(CONFIG.DASHBOARD.GET_PROJECTDASHBOARDDATA);
  }

  public getMyTask() {
    return this.httpClientService.get(CONFIG.PROJECTDASHBOARD.GET_MY_TASK);
  }
  
   public getMyPhases() {
    return this.httpClientService.get(CONFIG.PROJECTDASHBOARD.GET_MY_PHASES); 
  }
  public getAccountReceivableAndPayable() {
    return this.httpClientService.get(CONFIG.DASHBOARD.GET_ACCOUNT_RECEIVABLE_AND_PAYABLE);
  }
  // ================= ACCOUNTING DASHBOARD =================

public getIncomeExpenseChart(filter: string) {
  return this.httpClientService.get(
    `${CONFIG.DASHBOARD.GET_INCOME_EXPENSE_CHART}?filter=${filter}`
  );
}
public getCashflowChart(type: string) {
  return this.httpClientService.get(
    `${CONFIG.DASHBOARD.GET_CASH_FLOW_CHART}?type=${type}`
  );
}

public getTopExpenses() {
  return this.httpClientService.get(
    CONFIG.DASHBOARD.GET_TOP_EXPENSES
  );
}
public getTopReceivables() {
  return this.httpClientService.get(
    CONFIG.DASHBOARD.GET_TOP_RECEIVABLES
  );
}

public getTopPayables() {
  return this.httpClientService.get(
    CONFIG.DASHBOARD.GET_TOP_PAYABLES
  );
}

}
